import SteveSchema from '../steve-schema';

/**
 * This is the steve schema that's used for the management store
 */
export default class ManagementStoreSchema extends SteveSchema { }
